export const i18nLangs = ['en'];
